import {Component, OnInit, ViewChild} from '@angular/core';
import {FormGroup, FormBuilder, Validators, FormControl, FormArray} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {EMPTY, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, mergeMap} from 'rxjs/operators';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {ToasterService} from 'angular2-toaster';

import {LoanService} from '../../shared-component/service/loan/loan.service';
import {BypassRouteChangeService} from '../../shared-component/bypass-route-change/bypass-route-change.service';
import { PartnerService } from '../../shared-component/service/partner/partner.service';

@Component({
  selector: 'app-loan',
  templateUrl: './loan.component.html',
  styleUrls: ['./loan.component.scss']
})
export class LoanComponent implements OnInit {

  @ViewChild('popup') popUp: any;
  @ViewChild('popupCancelApplication') popupCancelApplication: any;

  public loanForm: FormGroup;
  public paymentScheduleForm: FormGroup;

  public tenures: any = [];
  public periodOfServiceArray: any = this.numberRange(3, 16);

  public paymentSchedule: any = [];
  public downPaymentSchedule: any = {};
  public hideServiceUserSameAsLoanTaker: boolean = false;
  public hidecourseDetails: boolean = false;
  public loanId: number;
  public leadDataList: any = [];
  public courseList: any = [];
  public branch: any = null;
  public actualLoanTenure : any = 0;
  public bankList : any = [];

  public bypassRouteChange = false;
  public showLeadInput = false;
  public selectedDom: any;
  public loanDataReceived: boolean = false;
  public courseListReceived: boolean = false;
  
  public searchTenure;
  
  public extraInfo = ['salutation', 'firstName', 'lastName', 'relationship', 'email'];
  
  public extraCourseInfo = ['courseName','other','courseTenure', 'universityName', 'enrollmentId'];

  public preProcessorFun: any;
  public postProcessorFun: any;

  public showStructuredEmi: boolean = false;

  public structuredEmiAmt: number = 0;
  public structuredEmiCount: number = 0;
  public structuredEmiList: any = [];
  public totalInterestAmount: any = 0;
  public totalPrincipalAmount: any = 0;
  public irrRate: any = 0;
  public scheduleDetail: any = 0;
  public loanDetail : any ={};

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private loanService: LoanService,
    private partnerService: PartnerService,
    private activeRoute: ActivatedRoute,
    private bypassRouteChangeService: BypassRouteChangeService,
    private toasterService: ToasterService
  ) {
    this.searchTenure = new Subject();
  }

  ngOnInit() {
    this.searchTenure.pipe(
      debounceTime(800),
      distinctUntilChanged(),
      mergeMap(value => {
        if (!value) {
          return EMPTY;
        }
        return this.loanService.getTenureList(value);
      })
    ).subscribe((tenure: any) => {
      this.tenures = tenure.data;
      let tenureValue = ""; 
      if(this.loanDetail && this.loanDetail.loanTerm){
        tenureValue = this.loanDetail.branchId+"-"+this.loanDetail.loanTerm;
      } 
      this.loanForm.patchValue({
        loanTerm: tenureValue
      });
    });

    this.loanForm = this.fb.group({
      loanAmount: ['', Validators.compose([Validators.required, Validators.min(0)])],
      loanTerm: ['', Validators.compose([Validators.required])],
      advanceToPartner: [''],
      advanceToTCPL: [''],
      moratoriumTenure: [''],
      /*periodOfService: ['', Validators.compose([Validators.required])],*/
      serviceUserSameAsLoanTaker: ['0', Validators.compose([Validators.required])],
      courseDetails: ['1', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.pattern(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]{2,3})*$/)])],
      partnerReferenceId: [''],
      enrollmentId: ['', Validators.compose([Validators.maxLength(20)])],
      salutation: ['', Validators.compose([Validators.required])],
      firstName: ['', Validators.compose([Validators.required])],
      lastName: ['', Validators.compose([Validators.required])],
      relationship: ['', Validators.compose([Validators.required])],
      courseName: ['', Validators.compose([Validators.required])],
      other: ['', Validators.compose([Validators.required])],
      courseTenure: ['', Validators.compose([Validators.required])],
      universityName: ['', Validators.compose([Validators.required])],
      branchDisburseBankId: ['']
    });    
    this.paymentScheduleForm = this.fb.group({
      paymentScheduleLoanAmount: ['', Validators.compose([Validators.required])],
      paymentScheduleLoanTerm: ['', Validators.compose([Validators.required])],
    });

    this.loanAmount.valueChanges.subscribe(v => this.paymentScheduleLoanAmount.setValue(v, {emitEvent: false}));
    this.paymentScheduleLoanAmount.valueChanges.subscribe(v => this.loanAmount.setValue(v, {emitEvent: false}));

    this.loanTerm.valueChanges.subscribe(v => this.paymentScheduleLoanTerm.setValue(v, {emitEvent: false}));
    this.paymentScheduleLoanTerm.valueChanges.subscribe(v => {
      this.loanTerm.setValue(v, {emitEvent: false});
      this.getAdvanceTenure(this.paymentScheduleLoanAmount.value, this.paymentScheduleLoanTerm.value);
    });

    this.loanAmount.valueChanges.subscribe(v => {
      this.loanTerm.setValue('');
    });

    this.paymentScheduleLoanAmount.valueChanges.subscribe(v => {
      this.paymentScheduleLoanTerm.setValue('');
    });

    this.serviceUserSameAsLoanTaker.valueChanges.subscribe((val) => {
      if (val === '1') {
        this.extraInfo.forEach((o) => {
          if (this.loanForm.get(o)) {
            this.loanForm.removeControl(o);
          }
        });
      }
      if (val === '0') {
        this.extraInfo.forEach((o) => {
          if (!this.loanForm.get(o)) {
            this.loanForm.addControl(o,
              new FormControl('', Validators.compose([Validators.required])));
          }
        });
      }
    });

    this.courseDetails.valueChanges.subscribe((val) => {
      // Making course details mandatory
      // if (val === '0') {
      //   this.extraCourseInfo.forEach((o) => {
      //     if (this.loanForm.get(o)) {
      //       this.loanForm.removeControl(o);
      //     }
      //   });
      // }
      if (val === '1') {
        this.extraCourseInfo.forEach((o) => {
          if (!this.loanForm.get(o)) {
            this.loanForm.addControl(o,
              new FormControl('', Validators.compose([Validators.required])));
          }
        });
      }
    });

    this.activeRoute.data.subscribe((res: any) => {
      if (res.loanDetail && res.loanDetail.eligibleAmount)
        this.hideServiceUserSameAsLoanTaker = true;
        this.hidecourseDetails = true;

      if (res.loanDetail && Object.keys(res.loanDetail).length) {
        this.loanDetail = res.loanDetail;
      
        this.loanId = res.loanDetail.id;
        this.loanAmount.setValidators(
          Validators.compose([
            Validators.required,
            Validators.min(res.loanDetail.minTicketSize),
            Validators.max(res.loanDetail.maxTicketSize),
          ])
        );

        this.paymentScheduleLoanAmount.setValidators(
          Validators.compose([
            Validators.required,
            Validators.min(res.loanDetail.minTicketSize),
            Validators.max(res.loanDetail.maxTicketSize),
          ])
        );

        this.loanForm.patchValue({
          periodOfService: res.loanDetail.periodOfService ? res.loanDetail.periodOfService : '',
          loanTerm: res.loanDetail.loanTerm ? res.loanDetail.loanTerm : '',
          serviceUserSameAsLoanTaker: '1',
          courseDetails: '1',
          courseName: res.loanDetail.courseName,
          courseTenure: res.loanDetail.courseTenure,
          universityName: res.loanDetail.universityName,
          enrollmentId: res.loanDetail.serviceUserEnrollmentId,
          partnerReferenceId: res.loanDetail.partnerReferenceId
        });
        
        this.loanService.getTenureList(res.loanDetail.eligibleAmount ? res.loanDetail.eligibleAmount : res.loanDetail.loanAmount).subscribe((tenure: any) => {
          this.tenures = tenure.data;

          let tenureValue = ""; 
          
          if(this.loanDetail && this.loanDetail.loanTerm){
            tenureValue = this.loanDetail.branchId+"-"+this.loanDetail.loanTerm;
          } 
          this.loanForm.patchValue({
            loanTerm: tenureValue
          });
        });

        this.loanForm.patchValue({
          loanAmount: res.loanDetail.eligibleAmount ? res.loanDetail.eligibleAmount : res.loanDetail.loanAmount,
        });

        if (res.loanDetail.personTakingSameAsPersonUsing !== null && res.loanDetail.personTakingSameAsPersonUsing === false) {
          this.loanForm.patchValue({
            serviceUserSameAsLoanTaker: '0',
            // courseDetails: '0',
            courseName: res.loanDetail && res.loanDetail.courseName ? res.loanDetail.courseName: '',
            courseTenure: res.loanDetail && res.loanDetail.courseTenure ? res.loanDetail.courseTenure: '',
            universityName: res.loanDetail && res.loanDetail.universityName ? res.loanDetail.universityName: '',
            enrollmentId: res.loanDetail  && res.loanDetail.serviceUserEnrollmentId ? res.loanDetail.serviceUserEnrollmentId: '',
            salutation: res.loanDetail && res.loanDetail.serviceUserSalutation ? res.loanDetail.serviceUserSalutation : 'Mr.',
            firstName: res.loanDetail && res.loanDetail.serviceUserFirstName ? res.loanDetail.serviceUserFirstName : '',
            lastName: res.loanDetail && res.loanDetail.serviceUserLastName ? res.loanDetail.serviceUserLastName : '',
            relationship: res.loanDetail && res.loanDetail.serviceUserRelationship ? res.loanDetail.serviceUserRelationship : '',
            email: res.loanDetail && res.loanDetail.serviceUserEmail ? res.loanDetail.serviceUserEmail : '',
          });
        }

        if (res.loanDetail && res.loanDetail.structuredEmis) {
          this.structuredEmiList = JSON.parse(res.loanDetail.structuredEmis);
          if(this.structuredEmiList.length) {
            this.showStructuredEmi = true;
          }
        }
  
        if (res.loanDetail && res.loanDetail.loanTerm && (res.loanDetail.eligibleAmount ? res.loanDetail.eligibleAmount : res.loanDetail.loanAmount)) {
          this.getAdvanceTenure((res.loanDetail.eligibleAmount ? res.loanDetail.eligibleAmount : res.loanDetail.loanAmount), res.loanDetail.loanTerm, res.loanDetail.branchId);
        }
  
      }
      this.loanDataReceived = true;
      this.courseNameSet();
      this.getDisbursementBanks();
    });
    
    this.partnerService.courseList().subscribe((res: any) => {
      this.courseList = res.data;
      this.courseListReceived = true;
      this.courseNameSet();
    });
  }

  get advanceToPartner() {
    return this.loanForm.get('advanceToPartner');
  }

  get advanceToTCPL() {
    return this.loanForm.get('advanceToTCPL');
  }

  get moratoriumTenure() {
    return this.loanForm.get('moratoriumTenure');
  }

  /*get periodOfService() {
    return this.loanForm.get('periodOfService');
  }*/

  get loanAmount() {
    return this.loanForm.get('loanAmount');
  }

  get loanTerm() {
    return this.loanForm.get('loanTerm');
  }

  get serviceUserSameAsLoanTaker() {
    return this.loanForm.get('serviceUserSameAsLoanTaker');
  }

  get courseDetails() {
    return this.loanForm.get('courseDetails');
  }

  get courseName() {
    return this.loanForm.get('courseName');
  }
  get other() {
    return this.loanForm.get('other');
  }
  get courseTenure() {
    return this.loanForm.get('courseTenure');
  }

  get universityName() {
    return this.loanForm.get('universityName');
  }

  get salutation() {
    return this.loanForm.get('salutation');
  }

  get firstName() {
    return this.loanForm.get('firstName');
  }

  get lastName() {
    return this.loanForm.get('lastName');
  }

  get relationship() {
    return this.loanForm.get('relationship');
  }

  get email() {
    return this.loanForm.get('email');
  }

  get enrollmentId() {
    return this.loanForm.get('enrollmentId');
  }

  get partnerReferenceId() {
    return this.loanForm.get('partnerReferenceId');
  }

  get branchDisburseBankId() {
    return this.loanForm.get('branchDisburseBankId');
  }
  
  get paymentScheduleLoanAmount() {
    return this.paymentScheduleForm.get('paymentScheduleLoanAmount');
  }

  get paymentScheduleLoanTerm() {
    return this.paymentScheduleForm.get('paymentScheduleLoanTerm');
  }


  courseNameSet(){
    let courseName = this.loanForm.get('courseName').value;
    if(this.loanDataReceived && this.courseListReceived){
      if(!this.courseList.find(e => e.Course.title == courseName)){
        this.loanForm.get('other').setValue(courseName);
        this.loanForm.get('courseName').setValue('OTHERS');
      }
    }
  }

  callLoanTermApiPaymentSchedule() {
    if (this.paymentScheduleLoanAmount.value) {
      this.loanService.getTenureList(this.paymentScheduleLoanAmount.value).subscribe((tenure: any) => {
        this.tenures = tenure.data;
      });
    }
  }

  customValidator() {
    /*return this.loanForm.get('periodOfService').value &&
      this.loanForm.get('loanAmount').value &&
      this.loanForm.get('loanTerm').value;*/
    return this.loanForm.get('loanAmount').value &&
      this.loanForm.get('loanTerm').value;
  }

  public numberRange(start: number, end: number) {
    let range: number[] = new Array(end - start);
    return range.fill(1).map((d, i) => i + start);
  }

  
  onSubmit(content, flag = true) {
    if(flag && this.downPaymentSchedule.supportStructuredEmis && this.structuredEmiList.length == 0){
      this.modalService.open(content, { backdrop: 'static'});
      return;
    }

    this._onSubmit();
  }

  parseLoanTenure(data = ""){
    let loanTerm = data || this.loanForm.get('loanTerm').value;
    let item = (loanTerm+"").split("-");
    if(item.length == 2){
      if(item[0])
        this.branch = item[0];
      if(item[1])
        loanTerm = item[1];
    } else {
      loanTerm = this.loanForm.get('loanTerm').value
    }
    this.actualLoanTenure = loanTerm;
  }

  _onSubmit() {
    this.parseLoanTenure();
    if(this.downPaymentSchedule.supportStructuredEmis){
      
    }
    
    let apiToCall;
    
    let formData = {
      partnerReferenceId: this.loanForm.get('partnerReferenceId').value,
      loanAmount: this.loanForm.get('loanAmount').value,
      loanTerm: this.actualLoanTenure,
      branch: this.branch,
      IRR : this.structuredEmiList.length ? this.irrRate : this.scheduleDetail.IRR,
      XIRR : this.structuredEmiList.length ? this.irrRate : this.scheduleDetail.XIRR,
      /*periodOfService: this.loanForm.get('periodOfService').value*/
      /*serviceAmount: this.loanForm.get('serviceAmount').value,*/
      branchDisburseBankId: this.loanForm.get('branchDisburseBankId').value
    };

    if (this.serviceUserSameAsLoanTaker.value === '0') {
      formData['serviceUserSameAsLoanTaker'] = false;
      this.extraInfo.forEach((o) => {
        if (this.loanForm.get(o).value.trim() != "") {
          formData[o] = this.loanForm.get(o).value.trim();
        }
      });
    } else {
      formData['serviceUserSameAsLoanTaker'] = true;
    }

    if (this.courseDetails.value === '1') {
      formData['courseDetails'] = true;
      this.extraCourseInfo.forEach((o) => {
        if (this.loanForm.get(o).value.toString().trim() != "") {
          formData[o] = this.loanForm.get(o).value.toString().trim();
        }
        this.loanForm.get('courseName').value == 'OTHERS' ?
          formData['courseName'] = this.loanForm.get('other').value.toString().trim() : '';
      });
    } else {
      formData['courseDetails'] = true;
    }

    if (this.showStructuredEmi && this.structuredEmiList.length) {
      formData['structuredEmis'] = this.structuredEmiList;
    }
    
    if (!this.loanId) {
      apiToCall = this.loanService.loanInit(formData);
    } else {
      apiToCall = this.loanService.loanUpdate(formData, this.loanId);
    }

    apiToCall.subscribe((res: any) => {
      this.bypassRouteChange = true;
      setTimeout(() => this.router.navigateByUrl(`/loanApplication/newLoanProcess/${ this.loanId ? this.loanId : res.data.id}/details`), 200);
    }, (errors) => {
      for (let error of errors) {
        if (!this.loanForm.get(error.field)) continue;
        this.loanForm.get(error.field).setErrors({server: error.message});
      }
    });
  }

  open(content) {
    this.modalService.open(content, {size: 'lg', backdrop: 'static'});
  }

  openPopup(clickAnchor = false) {
    if (this.loanAmount.value && this.loanTerm.value && this.loanAmount.valid) {
      this.getPaymentSchedule(clickAnchor);
    }
  }

  getPaymentSchedule(clickAnchor) {
    this.parseLoanTenure();
  
    this.loanService.paymentSchedule({
      loanAmount: this.loanAmount.value,
      loanTerm: this.actualLoanTenure,
      branch : this.branch
    }).subscribe((res: any) => {
      let aLoanAmount = this.loanAmount.value;
      this.downPaymentSchedule = res.data;
      this.paymentSchedule = [{
        balance: Math.round(res.data.balance)
      }, ...res.data.schedule.map((o, i) => {
        return {
          serialNo: ++i,
          paymentDate: o.date,
          interest: Math.round(o.interest),
          balance: Math.round(o.remainingBalance),
          paymentDue: Math.round(res.data.periodicPayment),
          principal: Math.round(o.principal),
          totalPaid: (Math.round(aLoanAmount - o.remainingBalance) * 100 / aLoanAmount).toFixed(2)
        };
      })];

      if (clickAnchor) {
        this.open(this.popUp);
      }
      if (this.structuredEmiList.length) {
        this.reCalculateSchedule();
      }
      this.generateChart();
    });
  }

  getAdvanceTenure(loanAmount, loanTerm, branch = "") {
    
    if(!branch){
      let item = loanTerm.split("-");
      if(item[0])
        branch = item[0];
      if(item[1])
        loanTerm = item[1];
      /*
      let item = this.tenures.filter( o => o.tenure == loanTerm);
      if(item.length){
        branch = item[0].branch;
      }
      */
    }
    if(!loanTerm) return false;
    this.branch = branch || false;
    this.actualLoanTenure = loanTerm;

    this.loanService.paymentSchedule({
      loanAmount: loanAmount,
      loanTerm: loanTerm,
      branch : this.branch
    }).subscribe((res: any) => {
      if (res.data) {
        this.scheduleDetail = res.data;
        this.moratoriumTenure.setValue(res.data.moratoriumTenure
          + ` month${res.data.moratorium > 1 ? 's' : ''}`),
        this.advanceToTCPL.setValue(res.data.advance.system.tenure
          + ` month${res.data.advance.system.tenure > 1 ? 's' : ''} (` + Math.round(res.data.advance.system.amount) + ')'),
          this.advanceToPartner.setValue(res.data.advance.partner.tenure
            + ` month${res.data.advance.partner.tenure > 1 ? 's' : ''} (` + Math.round(res.data.advance.partner.amount) + ')');
      }
      this.getPaymentSchedule(false);
    });

    this.getDisbursementBanks();
  }

  getDisbursementBanks(){
    this.loanService.getDisbursementList(this.branch, { active : true }).subscribe((res: any) => {
      this.bankList = res.data;
      if(!this.bankList.length){
        this.loanForm.patchValue({
          branchDisburseBankId : ""
        });
      } else {
        this.loanForm.patchValue({
          branchDisburseBankId : this.loanDetail.branchDisburseBankId
        });
      }
    });
  }

  reset(e: Event) {
    e.preventDefault();
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors = (control instanceof FormGroup || control instanceof FormArray)
        ? this.getAllErrors(control)
        : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
  }

  openContentCancelApplication(content) {
    this.modalService.open(content);
  }

  cancel() {
    this.openContentCancelApplication(this.popupCancelApplication);
  }

  cancelApplication() {
    this.bypassRouteChangeService.bypassRouteChange = true;
    this.router.navigateByUrl(`/application`).then(() => {
      this.bypassRouteChangeService.bypassRouteChange = false;
    });
  }
  
  capitalize(input) {
    if (input && input.trim()) {
      const trimmedInput = input.trim();
      const inputSplitBySpace = trimmedInput.split(" ");
      const capitalizedInputList = inputSplitBySpace.reduce((acc, val) => {
        return val ? acc.concat([val[0].toUpperCase() + val.slice(1, val.length)]) : acc;
      }, []);
      return capitalizedInputList.join(" ");
    }
    return input;
  } 

  /*********** Capture Lead **************/

  processLeadData(formData) {
    let content = formData.get("content").value;
    if (!content) {
      this.showLeadInput = false;
      return;
    }
    let prepare = content.split("\n");
    prepare = prepare.map((item: any) => {
      let data = item.split("-");
      if (data[1]) {
        data[1] = data[1].trim();
      }
      return data;
    });
    this.leadDataList = prepare;
    this.showLeadInput = false;
    localStorage.setItem('leadData', JSON.stringify(prepare));
    //console.log(prepare);
  }

  generateChart() {
    let tmp = [...this.paymentSchedule];
    tmp.shift();

    let data: any = tmp.reduce((o, i) => {
      o["interest"].push(Math.round(i.interest));
      o["principal"].push(Math.round(i.principal));
      o["outstanding"].push((100 - i.totalPaid).toFixed(2));
      o["emidate"].push(moment(i.paymentDate, 'YYYY-MM-DD').format('MM-YYYY'));
      o["amount"] += i.principal;
      o["totalinterest"] += i.interest;
      return o;
    }, { "amount": 0, "totalinterest": 0, "emidate": [], "interest": [], "principal": [], "outstanding": [] });

    data["advanceToPartner"] = !this.structuredEmiList.length ? (this.downPaymentSchedule.advance.partner.amount) || 0: 0;
    data["advanceToTCPL"] = !this.structuredEmiList.length ? (this.downPaymentSchedule.advance.system.amount) || 0 : 0;

    let chartSetting = {
      columns: [
        ['Outstanding', ...data["outstanding"]],
        ['Interest', ...data["interest"]],
        ['Principal', ...data["principal"]]
      ],
      axes: {
        Principal: 'y',
        Interest: 'y',
        Outstanding: 'y2'
      },
      type: 'bar',
      types: {
        "Outstanding": 'spline'
      },
      groups: [
        ['Interest', 'Principal']
      ]
    };

    if (this.structuredEmiList && this.structuredEmiList.length ) {
      let irrData = this.calculateIRR(false);
      chartSetting.columns.push(
        ['IRR Outstanding', ...irrData["pospercent"]],
        ['IRR Interest', ...irrData["interest"]],
        ['IRR Principal', ...irrData["principal"]]);

      chartSetting.axes["IRR Interest"] = 'y';
      chartSetting.axes["IRR Principal"] = 'y';
      chartSetting.axes["IRR Outstanding"] = 'y2';

      chartSetting.types["IRR Outstanding"] = 'spline';
      chartSetting.groups.push(['IRR Interest', 'IRR Principal']);
    }

    setTimeout(
      function () {
        window["c3"].generate({
          bindto: "#repay-chart",
          data: chartSetting,
          axis: {
            x: {
              type: 'category',
              tick: {
                rotate: 75,
                multiline: false
              },
              categories: data["emidate"]
            },
            y2: {
              show: true,
              max: 120,
              min: 1,
            }
          },
          zoom: {
              enabled: true
          }
        });

        window["c3"].generate({
          bindto: "#breakup-chart",
          data: {
            columns: [
              ['AdvanceToTCPL', data["advanceToTCPL"]],
              ['AdvanceToPartner', data["advanceToPartner"]],
              ['Principal', data["amount"]],
              ['Interest', data["totalinterest"]]
            ],
            type: 'pie'
          },
          legend: {
            position: 'right'
          },
          gauge: {
            label: {
              format: function (value, ratio) {
                return value.toFixed(2) + "%";
              }
            },
          },
          color: {
            pattern: ['#F97600', '#FF0000', '#F6C600', '#60B044'] // the three color levels for the percentage values.
          },
          size: {
            height: 200
          }
        });

      }, 500);
  }

  calulateAmounts() {
    if (this.structuredEmiCount > 0 && this.structuredEmiCount > 0) {
      let interest: any = this.getInterest();
      this.totalInterestAmount = (this.structuredEmiCount * interest).toFixed(0);
      let principal = this.structuredEmiAmt - interest;
      this.totalPrincipalAmount = (this.structuredEmiCount * principal).toFixed(0);
    }
  }

  addStructuredEmi() {
    if (this.structuredEmiCount <= 0) {
      return;
    }
    let totalEmi = this.structuredEmiList.reduce((a, item) => {
      a += item.emiCount;
      return a;
    }, 0);

    let interest: any = 0;
    interest = this.getInterest();;
    if ((totalEmi + this.structuredEmiCount) < this.actualLoanTenure ) {
      this.structuredEmiList.push({
        interestRate: this.downPaymentSchedule.interestRate,
        emiAmount: this.structuredEmiAmt,
        emiCount: this.structuredEmiCount,
        interest: interest,
        principal: this.structuredEmiAmt - interest,
        totalInterest: (this.structuredEmiCount * interest).toFixed(0),
        totalPrincipal: (this.structuredEmiCount * (this.structuredEmiAmt - interest)).toFixed(0)
      });

      let totalPrincipal = this.structuredEmiList.reduce((a, item) => {
        a += item.principal * item.emiCount;
        return a;
      }, 0);
      if(totalPrincipal >= this.loanAmount.value){
        this.structuredEmiList.pop();
        this.toasterService.pop('error', '', "Repay amount exceeds the loan amount.");
        return;
      }
      this.structuredEmiAmt = 0;
      this.reCalculateSchedule();
    } else {
      this.toasterService.pop('error', '', "Repay tenure exceeds the Total tenures.");
    }
    this.structuredEmiCount = this.actualLoanTenure - (totalEmi + this.structuredEmiCount ) -  1;
    this.totalInterestAmount = 0;
    this.totalPrincipalAmount = 0;
  }

  deleteStructuredEmi(index) {
    this.structuredEmiList.splice(index, 1);
    if (this.structuredEmiList.length)
      this.reCalculateSchedule();
    else
      this.openPopup();
  }

  reCalculateSchedule() {
    if (this.paymentSchedule && this.paymentSchedule.length) {
      let interest = this.getInterest();
      let balance = this.paymentSchedule[0].balance;
      if (this.structuredEmiList.length)
        balance = this.loanAmount.value;
      
      let data = { balance: balance };
      let paymentDate = moment(this.paymentSchedule[1].paymentDate);
      let month: any = moment(paymentDate, "YYYY-MM-DD").format("M");
      let year: any = moment(paymentDate, "YYYY-MM-DD").format("YYYY");
      let emiSrNo = 0;
      month--;
      let totalEmi = this.structuredEmiList.reduce((a, item) => {
        for (let i = 0; i < item.emiCount; i++) {
          let principal = item.emiAmount - interest;
          balance -= item.principal;
          month++;
          if (month == 13) {
            month = 1;
            year++;
          }
          let o = {
            serialNo: ++emiSrNo,
            paymentDate: year + "-" + month + "-05",
            principal: principal,
            interest: interest,
            paymentDue: item.emiAmount,
            balance: balance,
            totalPaid: (Math.round(this.loanAmount.value - balance) * 100 / this.loanAmount.value).toFixed(2)
          };

          a.push(o);
        }
        return a;
      }, []);

      let totalEmis = this.actualLoanTenure * 1;
      let principal = (balance / (totalEmis - emiSrNo));
      for (let i = emiSrNo; i < totalEmis; i++) {
        balance -= principal;
        month++;
        if (month == 13) {
          month = 1;
          year++;
        }
        let o = {
          serialNo: ++emiSrNo,
          paymentDate: year + "-" + month + "-05",
          principal: principal,
          interest: interest,
          paymentDue: (principal + interest),
          balance: balance,
          totalPaid: (Math.round(this.loanAmount.value - balance) * 100 / this.loanAmount.value).toFixed(2)
        };

        totalEmi.push(o);
      }
      this.paymentSchedule = [data, ...totalEmi];
      this.generateChart();
    }
  }

  getInterest() {
    if (this.downPaymentSchedule.interestRate)
      return (this.loanAmount.value * this.downPaymentSchedule.interestRate / 12 / 100) * 1;

    return 0;
  }

  calculateIRR(flag = true) {
    let CArray = [-this.paymentSchedule[0].balance];
    this.paymentSchedule.reduce((a, item) => {
      CArray.push(item.paymentDue);
    });

    let guest = 0.001;
    let inc = 0.000001;
    let NPV = 0;
    do {
      guest += inc;
      NPV = 0;
      for (var j = 0; j < CArray.length; j++) {
        NPV += CArray[j] / Math.pow((1 + guest), j);
      }
    } while (NPV > 0);

    this.irrRate = ((guest * 100) * 12);

    if (flag)
      return this.irrRate;

    let retVal = {
      interest : [],
      principal : [],
      pos : [],
      pospercent : []
    };

    let irr = this.irrRate/100;
    let balance = -CArray[0];
    for (var j = 1; j < CArray.length; j++) {
      let int = Math.round(balance * irr / 12);
      let principal = Math.round(CArray[j] - int);
      balance -= Math.round(principal);
      retVal.interest.push(int);
      retVal.principal.push(principal);
      retVal.pos.push(balance);
      retVal.pospercent.push((balance*100/-CArray[0]).toFixed(2));
    }
    return retVal;
  }

  downloadSchedule(){
    this.delayDownload(document.getElementById("emiSchedule").innerHTML);
  }

  tableToExcel() {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    return function (name, data) {
      var ctx = { worksheet: name || 'Worksheet', table: data }
      window.location.href = uri + base64(format(template, ctx))
    }
  };

  delayDownload(dataTable) {
    let oThat = this;
    setTimeout(function () {
      let dynFun: any = oThat.tableToExcel();
      dynFun("EMI-Schedule" , dataTable.replace(/₹/ig,""));
    }, 1000);
  }
}
